import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { ColumnExportButton, Table } from 'barnyard/components';
import { format_dollars } from '~/app/common/utils';


class OrderAlertTable extends PureComponent {
  typeHeader() {
    const { type } = this.props;
    switch (type) {
      case 'order':
        return 'Order #';
      case 'invoice':
        return 'Invoice #';
      case 'checkout':
        return 'Checkout #';
      default:
        return '#';
    }
  }

  linkUrl(value) {
    const { type } = this.props;
    switch (type) {
      case 'order':
        return <Link to={`/corporate/history/order/${value}`}>View Order</Link>;
      case 'invoice':
        return <Link to={`/corporate/invoices/invoices/${value}`}>View Invoice</Link>;
      case 'checkout':
        return <Link to={'/corporate/history/orders'}>View Orders</Link>;
      default:
        return '#';
    }
  }

  render() {
    const { orders, showTime, includeExport } = this.props;
    const { CellRenderers } = Table;
    const typeHeader = this.typeHeader();
    let columns = [{
      Header: 'Vetcove ID',
      accessor: 'id',
    }, {
      Header: 'Date',
      id: 'date',
      accessor: row => CellRenderers.renderDate({ value: row.date }),
    }];
    if (showTime) {
      columns.push({
        Header: 'Local Time',
        id: 'local_time',
        accessor: row => CellRenderers.renderTime({ value: row.time })
      });
    }
    const second_columns = [{
      Header: typeHeader,
      accessor: 'number',
    }, {
      Header: 'Supplier',
      accessor: 'supplier_name',
    }, {
      Header: 'Total',
      id: 'total',
      accessor: row => format_dollars({ integer: row.total, include_cents: true })
    }, {
      Header: 'Link',
      accessor: 'id',
      Cell: ({ value }) => this.linkUrl(value),
      includeInExport: false
    }];
    columns = columns.concat(second_columns);
    return (
      <Table
        actions={includeExport && (
          <div className='u-paddingTop10'>
            <ColumnExportButton
              filename='Vetcove_Order_Alerts.csv'
              data={orders}
              columns={columns}
            >
              Download
            </ColumnExportButton>
          </div>
        )}
        size='small'
        columns={columns}
        data={orders}
        pageSize={orders.length || 10}
        showPagination={false}
      />
    );
  }
}

OrderAlertTable.propTypes = {
  orders: PropTypes.array.isRequired,
  type: PropTypes.oneOf(['order', 'checkout', 'invoice']),
  showTime: PropTypes.bool,
  includeExport: PropTypes.bool
};

export default OrderAlertTable;
